import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelName, IApiConnectedAccount } from '../../types';
import { CHANNEL_INFO } from '../../constants';
import {
  AccountTabsContainer,
  AccountTab,
} from '../../styles/ManageChannelStyles';

interface IAccountTabsProps {
  accounts: IApiConnectedAccount[];
  selectedIndex: number;
  onSelectAccount: (index: number) => void;
  channelName: ChannelName;
}

const AccountTabs: FC<IAccountTabsProps> = memo(({
  accounts,
  selectedIndex,
  onSelectAccount,
  channelName,
}) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const channelInfo = CHANNEL_INFO[channelName];

  if (accounts.length <= 1) {
    return null;
  }

  return (
    <AccountTabsContainer>
      {accounts.map((account, index) => (
        <AccountTab
          key={account.id}
          $isActive={selectedIndex === index}
          onClick={() => onSelectAccount(index)}
        >
          {account.channelName || `${t('CHANNELS.ACCOUNT')} ${index + 1} ${isRtl ? channelInfo.displayNameAr : channelInfo.displayName}`}
        </AccountTab>
      ))}
    </AccountTabsContainer>
  );
});

AccountTabs.displayName = 'AccountTabs';

export default AccountTabs;
